export interface FilmCharacter {
  name: string;
  actor: string;
  role: string;
  description: string;
  traits: string[];
}

export interface Film {
  id: string;
  title: string;
  category: "movie" | "tv" | "web";
  year: number;
  region: "国产" | "欧美" | "日韩";
  genres: string[];
  director: string;
  cast: string[];
  rating: number;
  duration: string;
  poster: string;
  tags: string[];
  releaseDate: string;
  updatedAt: string;
  oneLine: string;
  synopsis: string[];
  characters: FilmCharacter[];
}

export const films: Film[] = [
  {
    id: "f001",
    title: "荒原信使",
    category: "movie",
    year: 2024,
    region: "国产",
    genres: ["剧情", "冒险"],
    director: "陈墨川",
    cast: ["林望舒", "赵砚清", "周砚舟"],
    rating: 8.6,
    duration: "128 分钟",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20traveler%20with%20a%20backpack%20walking%20across%20a%20vast%20golden%20desert%20at%20sunset%2C%20warm%20amber%20and%20orange%20sky%2C%20long%20shadow%2C%20dramatic%20dust%20light%2C%20muted%20earthy%20tones%2C%20minimal%20composition%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f001&orientation=portrait",
    tags: ["一路向西精选", "公路", "人文"],
    releaseDate: "2024-07-19",
    updatedAt: "2024-09-28",
    oneLine: "一封穿越荒原的信，串起陌生人之间最温柔的牵挂。",
    synopsis: [
      "在西部边缘的小镇上，邮差老周已经送信三十年。随着电子信件取代纸质信件，他的工作逐渐变得无足轻重，直到一封没有地址、只有一枚旧邮戳的挂号信出现在他的分拣台前。信封上写着“送往最远的那户人家”，没有收件人姓名，也没有完整的门牌号。",
      "为了完成这个看似荒唐的任务，老周骑上那辆破旧的摩托，沿着正在被沙化吞没的旧公路向西出发。一路上他遇见了离家出走的少年、守着废弃加油站的夫妻、以及靠记忆绘制地图的老测绘员。每个人都在信里看到了自己缺失的那部分人生。",
      "影片用克制而缓慢的镜头语言，把“送信”这件事拍成了一场关于告别的仪式。真正重要的从来不是信能否送达，而是有人在漫长的路上，愿意为一个陌生人多走一程。",
    ],
    characters: [
      { name: "老周", actor: "林望舒", role: "邮差 / 主角", description: "三十年如一日的老邮差，沉默寡言却认死理，他把送信当作一种承诺，哪怕这是最后一次。", traits: ["主角", "执拗", "温柔"] },
      { name: "小满", actor: "赵砚清", role: "出走少年", description: "厌倦小镇生活的少年，搭上老周的摩托，想去看一眼地图上那条消失的公路尽头。", traits: ["少年", "成长"] },
      { name: "测绘员老韩", actor: "周砚舟", role: "引路人", description: "靠记忆绘制地图的老人，他相信路一旦被记住，就永远不会真正消失。", traits: ["配角", "智者"] },
    ],
  },
  {
    id: "f002",
    title: "城市之光",
    category: "movie",
    year: 2023,
    region: "国产",
    genres: ["剧情", "犯罪"],
    director: "许知白",
    cast: ["沈砚", "梁清越", "陆怀安"],
    rating: 8.2,
    duration: "119 分钟",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20rainy%20city%20street%20at%20night%20with%20warm%20amber%20streetlights%20and%20wet%20reflective%20asphalt%2C%20a%20lone%20figure%20in%20a%20long%20coat%20walking%20away%2C%20moody%20orange%20glow%20against%20dark%20grey%20buildings%2C%20film%20noir%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f002&orientation=portrait",
    tags: ["悬疑", "都市", "人性"],
    releaseDate: "2023-11-03",
    updatedAt: "2024-08-14",
    oneLine: "在无人愿意作证的夜晚，一盏灯替真相说出了口。",
    synopsis: [
      "旧城区的拆迁工地上发现了一具无名尸体，而这起案件唯一的目击者，是一名患有夜盲症的路灯维修工。他记不清凶手的样子，却清楚记得案发那晚整条街唯一没有亮起的那盏灯。",
      "刑警队长沈砚接手案件后发现，这条街上每一盏路灯的开关记录都被删得干干净净，而能接触到系统的人屈指可数。随着调查深入，案件牵扯出开发商、社区和一名失踪多年的记者之间的旧账。",
      "影片把视角放在“沉默的普通人”身上，用一盏灯的明灭隐喻良知的选择。城市从不缺少光，缺的是愿意在黑暗里按下开关的人。",
    ],
    characters: [
      { name: "沈砚", actor: "沈砚", role: "刑警队长", description: "办案雷厉风行，却对旧城有着复杂的情感，他必须先直面自己曾经的选择。", traits: ["主角", "冷静"] },
      { name: "林阿婆", actor: "梁清越", role: "目击者", description: "守着老屋不肯搬走的老人，她的记忆片段成了撬动真相的关键。", traits: ["关键人物", "平凡英雄"] },
      { name: "开发商高远", actor: "陆怀安", role: "嫌疑人", description: "表面体面的商人，谈笑间藏着对这片土地最锋利的算计。", traits: ["反派", "精明"] },
    ],
  },
  {
    id: "f003",
    title: "归途列车",
    category: "tv",
    year: 2024,
    region: "国产",
    genres: ["家庭", "剧情"],
    director: "顾南春",
    cast: ["江叙", "苏晚", "程亦舟"],
    rating: 8.9,
    duration: "全 36 集",
    poster: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20poster%20of%20an%20old%20green%20train%20window%20with%20a%20middle%20aged%20man%20looking%20outside%2C%20golden%20sunset%20field%20passing%20by%2C%20soft%20sepia%20and%20warm%20orange%20tones%2C%20nostalgic%20family%20drama%20mood%2C%20gentle%20natural%20light%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f003&orientation=portrait",
    tags: ["一路向西精选", "家庭", "年代"],
    releaseDate: "2024-03-15",
    updatedAt: "2024-10-02",
    oneLine: "一列绿皮火车，载着一家人三十年的团圆与离别。",
    synopsis: [
      "故事从 1994 年的一个春运开始，铁路职工老江一家为了那张回家的票，在车站整整熬了两个通宵。此后每一年，这条归途都成为这个普通家庭的缩影——有人离开，有人回来，有人永远留在了路上。",
      "剧集以每一年的春运为时间坐标，串联起这个家庭三代人的变迁：父亲老江坚守岗位直到退休，大女儿远嫁他乡，小儿子成为新一代的铁路人。铁路在变迁，绿皮车换成了高铁，但“回家”这件事从未改变。",
      "《归途列车》不追求强情节，它用大量真实的细节铺陈日常：站台上的告别、饭桌上的沉默、行李箱里的特产。它讲的是每一个中国家庭都经历过，却很少被认真讲述的团圆。",
    ],
    characters: [
      { name: "老江", actor: "江叙", role: "铁路职工 / 父亲", description: "一辈子守着车站的男人，把对家人的爱藏进了每一张提前买好的票里。", traits: ["主角", "父辈", "坚韧"] },
      { name: "苏晚", actor: "苏晚", role: "大女儿", description: "为了爱情远走他乡的长女，每年春运都在归途与远方之间反复拉扯。", traits: ["长女", "矛盾"] },
      { name: "江叙舟", actor: "程亦舟", role: "小儿子", description: "接过父亲接力棒的新一代铁路人，见证着从绿皮车到高铁的时代跨越。", traits: ["新生代", "成长"] },
    ],
  },
  {
    id: "f004",
    title: "午夜信号",
    category: "movie",
    year: 2022,
    region: "欧美",
    genres: ["悬疑", "科幻"],
    director: "Elena Marsh",
    cast: ["Oliver Reed", "Clara Blythe", "Marcus Hale"],
    rating: 8.4,
    duration: "112 分钟",
    poster: "https://readdy.ai/api/search-image?query=Moody%20sci%20fi%20movie%20poster%20of%20an%20old%20radio%20tower%20on%20a%20hill%20under%20a%20dramatic%20orange%20dusk%20sky%2C%20static%20signal%20waves%20in%20the%20air%2C%20lone%20operator%20silhouette%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20tense%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f004&orientation=portrait",
    tags: ["悬疑", "科幻", "烧脑"],
    releaseDate: "2022-10-21",
    updatedAt: "2024-06-30",
    oneLine: "凌晨三点，一段不该存在的广播让小镇的夜晚再也无法平静。",
    synopsis: [
      "深山的无线电观测站里，值班员在一次例行扫描中捕捉到一段无法解释的信号。信号里反复播放着同一段话，而说话的声音，正是他自己。更奇怪的是，信号里描述的事件，会在第二天分毫不差地发生。",
      "为了弄清真相，值班员开始记录信号内容并尝试干预，但每当他试图改变结果，信号就会变得更加频繁而尖锐。他的同事开始怀疑他精神失常，而唯一相信他的，是一位研究多年、早已被学界排挤的老学者。",
      "影片用近乎冷静的节奏铺陈悬疑，让观众与主角一同在“预知”与“宿命”之间挣扎。最后的转折留给每个观众一个问题：如果我们能听见未来，我们真的愿意改变它吗？",
    ],
    characters: [
      { name: "Thomas", actor: "Oliver Reed", role: "值班员 / 主角", description: "孤独而严谨的信号观测员，他越试图理解信号，就越接近自己隐藏的秘密。", traits: ["主角", "偏执"] },
      { name: "Clara", actor: "Clara Blythe", role: "老学者", description: "被学界抛弃的电磁学研究者，她早就知道这种信号存在，只是没人在意。", traits: ["引路人", "智慧"] },
      { name: "Marcus", actor: "Marcus Hale", role: "同事", description: "务实的搭档，起初怀疑主角，最终成为唯一陪他走到最后的人。", traits: ["配角", "忠诚"] },
    ],
  },
  {
    id: "f005",
    title: "樱色的夏天",
    category: "tv",
    year: 2023,
    region: "日韩",
    genres: ["爱情", "剧情"],
    director: "佐藤悠介",
    cast: ["松本遥", "井上芽衣", "铃木航"],
    rating: 8.1,
    duration: "全 16 集",
    poster: "https://readdy.ai/api/search-image?query=Soft%20romantic%20poster%20of%20pink%20cherry%20blossoms%20over%20a%20quiet%20small%20town%20street%20in%20Japan%2C%20two%20young%20figures%20walking%20under%20petals%2C%20warm%20gentle%20afternoon%20light%2C%20pastel%20warm%20peach%20and%20cream%20tones%2C%20nostalgic%20tender%20mood%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f005&orientation=portrait",
    tags: ["纯爱", "治愈", "日韩"],
    releaseDate: "2023-04-08",
    updatedAt: "2024-05-22",
    oneLine: "那年夏天的樱花落得很慢，慢到足够两个人说完再见。",
    synopsis: [
      "搬到海边小镇的高中生遥，在转学第一天遇见了总是一个人在樱花树下画画的芽衣。两人因为一幅未完成的画结缘，约定一起在毕业前种下一棵樱花树。",
      "随着夏天的深入，遥逐渐发现芽衣隐瞒着要离开小镇的秘密。他一边假装不知情，一边拼命想留住那个夏天。剧集用大量细腻的日常片段，把青春里那种“明知会失去却仍在挽留”的心情拍得格外真实。",
      "结局没有刻意的团圆，只有一辆驶离小站的电车和一封迟到的信。但正因为遗憾，那个夏天才显得格外明亮。",
    ],
    characters: [
      { name: "松本遥", actor: "松本遥", role: "转学生 / 主角", description: "来自城市的内向少年，用笨拙的方式守护着重要的约定。", traits: ["主角", "温柔"] },
      { name: "井上芽衣", actor: "井上芽衣", role: "画画的少女", description: "总在樱花树下作画的女孩，藏着不愿说出口的告别。", traits: ["女主", "隐忍"] },
      { name: "铃木航", actor: "铃木航", role: "好友", description: "热爱摄影的挚友，用镜头替两人留住了那个夏天。", traits: ["配角", "友情"] },
    ],
  },
  {
    id: "f006",
    title: "钢铁黎明",
    category: "movie",
    year: 2025,
    region: "欧美",
    genres: ["动作", "科幻"],
    director: "Marcus Hale",
    cast: ["Damon Cross", "Iris Vale", "Noah Sterling"],
    rating: 8.0,
    duration: "134 分钟",
    poster: "https://readdy.ai/api/search-image?query=Epic%20sci%20fi%20action%20poster%20of%20a%20giant%20humanoid%20machine%20silhouette%20against%20a%20burning%20orange%20dawn%20horizon%2C%20distant%20ruined%20city%20skyline%2C%20dramatic%20backlight%2C%20warm%20amber%20fire%20glow%20and%20dark%20steel%20tones%2C%20heroic%20tense%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f006&orientation=portrait",
    tags: ["机甲", "科幻", "热血"],
    releaseDate: "2025-01-17",
    updatedAt: "2025-02-09",
    oneLine: "当机器学会守护，人类才第一次懂得了什么叫黎明。",
    synopsis: [
      "在被战争摧残的废土上，一台被遗弃的旧式机甲被工程师艾瑞斯重新唤醒。她发现这台机甲的作战系统里，残留着上一任驾驶员全部的记忆与情感。",
      "随着敌对势力逼近最后的定居点，艾瑞斯必须驾驶这台承载着别人记忆的机甲迎战。机甲每一次启动，都会让那段不属于她的记忆变得更加清晰，也让她越来越分不清，自己究竟是在守护家园，还是在替某个人完成遗愿。",
      "影片在宏大场面之外，把重心放在“人与机器”的羁绊上。它不是一部单纯的爽片，而是一个关于记忆、传承与选择的故事。",
    ],
    characters: [
      { name: "Iris", actor: "Iris Vale", role: "工程师 / 驾驶员", description: "天才工程师，被迫从修理工变成战士，在记忆与自我之间寻找平衡。", traits: ["主角", "坚韧"] },
      { name: "Damon", actor: "Damon Cross", role: "前驾驶员记忆", description: "只存在于机甲系统中的声音，用回忆指引着后来的守卫者。", traits: ["灵魂", "旁白"] },
      { name: "Noah", actor: "Noah Sterling", role: "指挥官", description: "冷静果断的定居点领袖，背负着所有人的生死抉择。", traits: ["配角", "领袖"] },
    ],
  },
  {
    id: "f007",
    title: "山河故人志",
    category: "tv",
    year: 2024,
    region: "国产",
    genres: ["历史", "剧情"],
    director: "裴之衡",
    cast: ["顾长风", "温言", "贺兰之"],
    rating: 9.0,
    duration: "全 40 集",
    poster: "https://readdy.ai/api/search-image?query=Grand%20historical%20Chinese%20drama%20poster%20of%20an%20ancient%20city%20under%20a%20vast%20orange%20sunset%20sky%2C%20ink%20wash%20style%20mountains%2C%20a%20scholar%20figure%20gazing%20at%20the%20horizon%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20epic%20solemn%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f007&orientation=portrait",
    tags: ["历史", "群像", "史诗"],
    releaseDate: "2024-05-10",
    updatedAt: "2024-09-18",
    oneLine: "乱世之中，一群读书人用笔墨守住了最后一座城。",
    synopsis: [
      "朝代更迭的前夜，一座边陲书院成为无数读书人最后的庇护所。院长顾长风带着学生们一面整理即将散佚的典籍，一面在乱军与流民之间艰难周旋。",
      "剧集以群像视角展开，刻画了性格各异的数十位读书人：有人坚守气节，有人选择妥协，有人在理想与现实之间反复摇摆。每个人物都对应着一种面对乱世的态度。",
      "《山河故人志》的野心不在于讲述一场战争，而在于记录一个文明如何在最黑暗的时刻，靠一群普通人的坚持被保留下来。它让观众明白，历史的重量往往压在不起眼的人肩上。",
    ],
    characters: [
      { name: "顾长风", actor: "顾长风", role: "书院院长", description: "以文载道的一代大儒，用一生践行“读书人当为天下守心”的信念。", traits: ["主角", "风骨"] },
      { name: "温言", actor: "温言", role: "女弟子", description: "出身将门却一心向学的女子，在战乱中展现出超越性别的担当。", traits: ["女主", "果敢"] },
      { name: "贺兰之", actor: "贺兰之", role: "叛将", description: "曾经的书院学生，最终成为率军围城的将领，与师门站在了对立面。", traits: ["反派", "悲剧"] },
    ],
  },
  {
    id: "f008",
    title: "逆风飞翔",
    category: "web",
    year: 2024,
    region: "国产",
    genres: ["青春", "励志"],
    director: "林一诺",
    cast: ["程野", "夏芷", "方晓阳"],
    rating: 7.8,
    duration: "全 24 集",
    poster: "https://readdy.ai/api/search-image?query=Youthful%20uplifting%20poster%20of%20a%20young%20runner%20sprinting%20on%20a%20track%20at%20golden%20hour%2C%20motion%20blur%20background%2C%20warm%20orange%20sunlight%20flares%2C%20energetic%20hopeful%20mood%2C%20clean%20ski%20blue%20and%20amber%20tones%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f008&orientation=portrait",
    tags: ["青春", "热血", "校园"],
    releaseDate: "2024-06-28",
    updatedAt: "2024-08-30",
    oneLine: "所有人都说他会放弃，只有他自己相信风总会转向。",
    synopsis: [
      "高三学生程野因为一场意外失去了原本的优势，从校队的种子选手变成了无人看好的替补。为了争取一次代表学校出战的机会，他必须在半年里完成几乎不可能的训练计划。",
      "剧集围绕校园赛场展开，既有紧张的比赛场面，也有少年之间纯粹的友谊与懵懂的喜欢。程野在一次次失败中学会的不是如何赢，而是如何在明知希望渺茫时依然向前。",
      "《逆风飞翔》没有给主角开挂，他所有的进步都来自反复的跌倒与爬起。它想说的是：逆风不是阻碍，而是让你飞得更高的那段上坡路。",
    ],
    characters: [
      { name: "程野", actor: "程野", role: "高三学生 / 主角", description: "曾经的天才少年，跌落低谷后靠着一股不服输的劲重新站起。", traits: ["主角", "热血"] },
      { name: "夏芷", actor: "夏芷", role: "队医", description: "细心又倔强的队医，是程野训练场上最坚定的支持者。", traits: ["女主", "温柔"] },
      { name: "方晓阳", actor: "方晓阳", role: "挚友兼对手", description: "一路与程野既竞争又并肩的队友，用实力逼出彼此最好的状态。", traits: ["配角", "对手"] },
    ],
  },
  {
    id: "f009",
    title: "玻璃迷城",
    category: "movie",
    year: 2023,
    region: "日韩",
    genres: ["悬疑", "犯罪"],
    director: "朴承宇",
    cast: ["金瑞俊", "李하늘", "崔镇浩"],
    rating: 8.3,
    duration: "124 分钟",
    poster: "https://readdy.ai/api/search-image?query=Sleek%20crime%20thriller%20poster%20of%20a%20glass%20skyscraper%20facade%20reflecting%20a%20warm%20orange%20dusk%2C%20a%20detective%20silhouette%20looking%20up%2C%20geometric%20mirrored%20patterns%2C%20cool%20grey%20and%20warm%20amber%20contrast%2C%20tense%20mysterious%20mood%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f009&orientation=portrait",
    tags: ["悬疑", "犯罪", "反转"],
    releaseDate: "2023-09-14",
    updatedAt: "2024-04-11",
    oneLine: "在一座全部由玻璃砌成的城市里，没有人能藏住秘密。",
    synopsis: [
      "一名以冷静著称的金融分析师被发现死于自己设计的玻璃塔楼顶层，现场没有任何入侵痕迹。警方认定为自杀，但负责此案的侦探却发现，死者生前最后一条信息，指向了一桩尘封十年的旧案。",
      "随着调查展开，案件牵出了这座城市最顶层的一群人——他们靠着精密的金融设计与完美的说辞，把真相藏在高楼玻璃的反光背后。侦探必须在层层谎言中，找到唯一没有被篡改的那个细节。",
      "影片以冷峻的都市景观与大量镜像构图，讨论“越透明越封闭”的现代寓言。玻璃能映出一切，却也能把真实的裂缝藏得滴水不漏。",
    ],
    characters: [
      { name: "金瑞俊", actor: "金瑞俊", role: "侦探", description: "不信巧合、只信证据的刑警，擅长在最完美的谎言里找出那一丝裂缝。", traits: ["主角", "缜密"] },
      { name: "李하늘", actor: "李하늘", role: "分析师", description: "死者的搭档，表面冷静克制，内心却背负着与旧案有关的秘密。", traits: ["关键人物", "隐情"] },
      { name: "崔镇浩", actor: "崔镇浩", role: "财团掌舵人", description: "站在玻璃塔顶层的男人，微笑背后是整个城市最锋利的规则。", traits: ["反派", "城府"] },
    ],
  },
  {
    id: "f010",
    title: "星尘旅途",
    category: "movie",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "冒险"],
    director: "Sofia Lindqvist",
    cast: ["Ava Nyberg", "Leo Frost", "Mira Dusk"],
    rating: 8.5,
    duration: "141 分钟",
    poster: "https://readdy.ai/api/search-image?query=Beautiful%20space%20adventure%20poster%20of%20a%20small%20lone%20spaceship%20drifting%20toward%20a%20warm%20golden%20nebula%2C%20vast%20starry%20cosmos%2C%20amber%20and%20deep%20indigo%20tone%2C%20glowing%20dust%20particles%2C%20serene%20wondrous%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f010&orientation=portrait",
    tags: ["科幻", "太空", "治愈"],
    releaseDate: "2025-03-07",
    updatedAt: "2025-04-01",
    oneLine: "跨越半生的星尘，只为把一句迟到的告别送到终点。",
    synopsis: [
      "一名独自驾驶老旧飞船的星际信使，接到了职业生涯里最后一单任务：把一枚数据胶囊送往人类已知宇宙最遥远的殖民地。胶囊里装着的，是一位老人留给几代后人的遗言。",
      "旅程漫长而孤独，飞船每一次穿越星云，都会播放一段胶囊里解压出来的旧影像。信使一点点拼凑出这段跨越数十年的家族故事，也渐渐明白，自己护送的其实是一份未被完成的牵挂。",
      "影片用极简的叙事和广阔的宇宙景观，把“孤独”与“连接”拍得既辽阔又温柔。终点或许无人等候，但旅途本身，就是最好的送达。",
    ],
    characters: [
      { name: "Ava", actor: "Ava Nyberg", role: "星际信使 / 主角", description: "最后一位还在跑长途的星际船员，习惯孤独却在旅程中重新学会牵挂。", traits: ["主角", "孤勇"] },
      { name: "Leo", actor: "Leo Frost", role: "老人（影像）", description: "只存在于旧影像里的老人，用一段段留言讲述了一个家族的一生。", traits: ["灵魂人物", "回忆"] },
      { name: "Mira", actor: "Mira Dusk", role: "地面联络员", description: "隔着光年陪伴信使的年轻联络员，是漫长旅途中唯一的声音。", traits: ["配角", "陪伴"] },
    ],
  },
  {
    id: "f011",
    title: "巷口烟火",
    category: "web",
    year: 2023,
    region: "国产",
    genres: ["都市", "爱情"],
    director: "苏青禾",
    cast: ["林晚", "顾栖", "阿源"],
    rating: 7.9,
    duration: "全 30 集",
    poster: "https://readdy.ai/api/search-image?query=Cozy%20urban%20romance%20poster%20of%20a%20small%20warm%20alley%20food%20stall%20at%20dusk%20with%20glowing%20string%20lights%2C%20steam%20rising%2C%20warm%20orange%20lamplight%20and%20soft%20cream%20tones%2C%20intimate%20everyday%20mood%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f011&orientation=portrait",
    tags: ["都市", "美食", "治愈"],
    releaseDate: "2023-12-01",
    updatedAt: "2024-07-05",
    oneLine: "一条老巷，一口热锅，藏着这座城市最踏实的爱情。",
    synopsis: [
      "辞掉大厂工作回到老城区的林晚，接下了外婆留下的小炒摊。她本以为这只是过渡，却在一次次深夜收摊、和熟客闲聊、和邻摊拌嘴中，慢慢找回了生活的节奏。",
      "隔壁开面馆的顾栖嘴硬心软，两人从互相嫌弃到并肩守摊，把一条快被遗忘的老巷重新聚起了烟火气。剧集用一餐一饭串起都市里最细碎的温柔。",
      "《巷口烟火》没有大起大落，它把镜头对准那些认真生活的普通人。最动人的告白，往往就是一句“今天这碗面，多给你加了个蛋”。",
    ],
    characters: [
      { name: "林晚", actor: "林晚", role: "炒摊主 / 主角", description: "辞职回乡的都市白领，在烟火气里重新找到生活的方向。", traits: ["主角", "通透"] },
      { name: "顾栖", actor: "顾栖", role: "面馆老板", description: "嘴硬心热的邻摊老板，用最朴素的方式守护着身边的人。", traits: ["男主", "踏实"] },
      { name: "阿源", actor: "阿源", role: "跑腿小哥", description: "跑遍全城的外卖骑手，是整条巷子消息最灵通的“活地图”。", traits: ["配角", "热心"] },
    ],
  },
  {
    id: "f012",
    title: "深海回响",
    category: "movie",
    year: 2024,
    region: "国产",
    genres: ["科幻", "灾难"],
    director: "梁观澜",
    cast: ["秦越", "沈知微", "韩川"],
    rating: 8.7,
    duration: "130 分钟",
    poster: "https://readdy.ai/api/search-image?query=Deep%20sea%20sci%20fi%20disaster%20poster%20of%20a%20lone%20submersible%20sinking%20into%20a%20dark%20abyss%20with%20a%20single%20warm%20amber%20light%20beam%2C%20deep%20teal%20water%20and%20orange%20glow%2C%20tiny%20fragile%20submarine%20against%20vast%20ocean%2C%20tense%20awe%20inspiring%20atmosphere%2C%20high%20detail%20cinematic%20photography&width=600&height=900&seq=poster-f012&orientation=portrait",
    tags: ["科幻", "灾难", "海洋"],
    releaseDate: "2024-08-09",
    updatedAt: "2024-10-11",
    oneLine: "当海底传来不该存在的回响，人类才知道自己有多渺小。",
    synopsis: [
      "深海科考站“渊阁”在例行勘探中，于海沟最深处捕捉到一段重复出现的低频声波。声波既不像地质活动，也不属于任何已知生物，它出现的时间间隔，恰好与人体的某种生物节律完全一致。",
      "站长秦越带领团队深入海沟取样，却在返航途中遭遇了罕见的深海地质塌陷。潜艇受损、通讯中断，队员必须在有限的氧气与不断恶化的环境中，找出声波的来源，才能找到唯一的生路。",
      "影片在紧张刺激的灾难场景之外，保留了对于海洋与未知的敬畏。它既是一场绝境求生，也是一次对人类傲慢的冷静审视——深海从不属于我们，我们只是偶尔被允许停留。",
    ],
    characters: [
      { name: "秦越", actor: "秦越", role: "科考站站长", description: "经验丰富却背负着一次失败救援过去的领队，这次他必须做出不同的选择。", traits: ["主角", "担当"] },
      { name: "沈知微", actor: "沈知微", role: "生物声学专家", description: "执着于那段神秘声波的研究员，她相信答案会让所有人活下来。", traits: ["女主", "执着"] },
      { name: "韩川", actor: "韩川", role: "潜艇驾驶员", description: "技术过硬、话不多的老船员，在关键时刻成为所有人最后的依靠。", traits: ["配角", "可靠"] },
    ],
  },
];

export interface CategoryMeta {
  key: string;
  name: string;
  title: string;
  description: string;
  icon: string;
}

export const categoryMeta: CategoryMeta[] = [
  { key: "movie", name: "电影", title: "电影栏目", description: "聚焦大银幕佳作，从剧情解析到幕后故事，为你呈现完整的电影阅读体验。", icon: "ri-film-line" },
  { key: "tv", name: "电视剧", title: "电视剧栏目", description: "长篇剧集深度梳理，人物关系与剧情脉络一目了然，追剧不再迷路。", icon: "ri-tv-2-line" },
  { key: "web", name: "网络剧", title: "网络剧栏目", description: "年轻化、快节奏的网络剧集精选，新鲜题材与都市情感一站看全。", icon: "ri-smartphone-line" },
];

export const regionOptions = ["国产", "欧美", "日韩"];
export const genreOptions = ["剧情", "冒险", "犯罪", "家庭", "悬疑", "科幻", "爱情", "动作", "历史", "青春", "励志", "都市", "灾难"];
export const yearOptions = [2025, 2024, 2023, 2022, 2021];